import React from 'react';
import RangeIndicatorChart from './RangeIndicatorChart';

interface ImcResultadoProps {
  peso?: number;
  altura?: number;
}

const getImcCategoria = (imc: number): string => {
  if (imc < 18.5) return 'Abaixo do peso';
  if (imc < 25) return 'Peso normal';
  if (imc < 30) return 'Sobrepeso';
  if (imc < 35) return 'Obesidade grau I';
  if (imc < 40) return 'Obesidade grau II';
  return 'Obesidade grau III';
};

const ImcResultado: React.FC<ImcResultadoProps> = ({ peso, altura }) => {
  if (!peso || !altura || altura === 0) return null;

  const imc = peso / (altura * altura);
  const categoria = getImcCategoria(imc);

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
        IMC: {imc.toFixed(1)} ({categoria})
      </div>
      <RangeIndicatorChart
        value={imc}
        title="IMC"
        faixas={[
            { label: 'Abaixo do peso', cor: '#ADD8E6', min: 0, max: 18.5 },
            { label: 'Normal', cor: '#90EE90', min: 18.5, max: 24.9 },
            { label: 'Sobrepeso', cor: '#FFD700', min: 24.9, max: 29.9 },
            { label: 'Obesidade', cor: '#FF7F7F', min: 29.9, max: 50 },
        ]}
        />
    </div>
  );
};

export default ImcResultado;
